var map = {
	"./UAE.png": "579b",
	"./brazil.png": "793f",
	"./cambodia.png": "5121",
	"./china.png": "6bbd",
	"./england.png": "9231",
	"./hong_kong.png": "7a4e",
	"./japan.png": "b193",
	"./malaysia.png": "3a19",
	"./philippine.png": "18ae",
	"./portugal.png": "b8d2",
	"./singapore.png": "c05a",
	"./thailand.png": "6476",
	"./vietnam.png": "906b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "620e";